import {useEffect, useState} from "react"
import {BooksitoutServer} from "../../../../config/BooksitoutServer"

const useBookSubscription = (isbn13: string) => {
    const [books, setBooks] = useState<BookSubscriptionResponse[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        if (isbn13 !== '') {
            BooksitoutServer
                .get(`/v1/book/search/sources/subscription?isbn13=${isbn13}`)
                .then((res) => setBooks(res.data))
                .finally(() => setIsLoading(false))
        }
    }, [isbn13])

    return [books, isLoading] as const
}

interface BookSubscriptionResponse {
    link: string
    provider: string
    label: string
    imageUrl: string
}

export default useBookSubscription
